import { render, staticRenderFns } from "./question-view.vue?vue&type=template&id=56c8c9d2"
import script from "./question-view.vue?vue&type=script&lang=js"
export * from "./question-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports